import React, { useCallback, useState } from "react";

/** Önce `/brand/footer-logo.webp` (şeffaf); yüklenemezse → footer-logo.png. */
export default function FooterLogo() {
  const [useFallback, setUseFallback] = useState(false);
  const onError = useCallback(() => setUseFallback(true), []);
  const base = process.env.PUBLIC_URL || "";

  const primary = `${base}/brand/footer-logo.webp`;
  const fallback = `${base}/brand/footer-logo.png`;

  return (
    <img
      src={useFallback ? fallback : primary}
      alt="CommodityBid — Find The Best Price"
      className="h-14 sm:h-16 md:h-[4.75rem] w-auto max-w-[min(100%,380px)] object-contain object-left block bg-transparent"
      width={380}
      height={110}
      loading="lazy"
      decoding="async"
      onError={useFallback ? undefined : onError}
    />
  );
}
